module.exports = __webpack_public_path__ + "img/slider_aumenta.0cbb9e28.png";